import { render, staticRenderFns } from "./CambiaStatoPratica.vue?vue&type=template&id=3ef7a256&scoped=true&"
import script from "./CambiaStatoPratica.vue?vue&type=script&lang=js&"
export * from "./CambiaStatoPratica.vue?vue&type=script&lang=js&"
import style0 from "./CambiaStatoPratica.vue?vue&type=style&index=0&id=3ef7a256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef7a256",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QInput});
